import { useTranslation } from 'react-i18next'
import { GridOverlay } from '@mui/x-data-grid'
import TableEmptyState from './TableEmptyState'

const NoRowsOverlay = () => {
  const { t } = useTranslation()

  return (
    <GridOverlay>
      <div style={{ width: '100%', padding: '8px 0' }}>
        <TableEmptyState
          compact
          title={t('listPages.emptyTitle')}
          hint={t('listPages.emptyHint')}
        />
      </div>
    </GridOverlay>
  )
}

export default NoRowsOverlay
